import { X_SOURCE_APP } from '~/constants/yocketConstants';

const CMS_API = process.env.CMS_API;
const headers = {
    'x-source-app': X_SOURCE_APP.SUPERTEST
};
export default (http, resource, apiVersion) => ({
    getGuideTabs(slug) {
        const method = 'get';
        const url = `${CMS_API}/${apiVersion}/${resource}/exam/${slug}/tabs`;
        return http({ method, url, headers });
    },
    getGuideData(slug, tabSlug) {
        const method = 'get';
        const url = `${CMS_API}/${apiVersion}/${resource}/exam/${slug}/${tabSlug}`;
        return http({ method, url, headers });
    }
});
